import type { PaymentAdapter } from "./customGatewayAdapter";
import { normalizeResponse } from "../core/normalizeResponse";

export const popupAdapter: PaymentAdapter = async (session, input) => {
  const url = session.checkoutUrl ?? session.redirectUrl;

  if (!url) {
    return normalizeResponse({
      status: "pending",
      input,
      rawResponse: session,
      message: "Payment session created"
    });
  }

  const popup = window.open(url, "startbutton-payment-gateway", "width=480,height=720,noopener,noreferrer");
  if (!popup) {
    return normalizeResponse({
      status: "failed",
      input,
      rawResponse: session,
      errorCode: "POPUP_BLOCKED",
      message: "Payment popup was blocked by the browser"
    });
  }

  return normalizeResponse({
    status: "pending",
    input,
    rawResponse: session,
    message: "Payment popup opened"
  });
};
